<template>
  <div class="cy-region-picker">
    <label>{{ title }}</label>
    <el-select
      v-model="curProvince"
      @change="handleCommand($event, 'region')"
    >
      <el-option
        v-for="(item, index) in regionList"
        :key="index"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
    <el-select
      v-model="curCity"
      v-show="isShowSubRegion"
      @change="handleCommand($event, 'city')"
    >
      <el-option
        v-for="(item, index) in cityList"
        :key="index"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    regionList: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: () => '地域：'
    },
    initProvince: {
      type: String,
      default: () => ''
    },
    initCity: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    cityList() {
      let filterId = this.curProvince || this.initProvince
      let result = this.regionList.filter(
        item => String(item.id) === filterId
      )[0]
      return result
        ? [{ name: '全部', id: '', children: [] }, ...result.children]
        : []
    },
    isShowSubRegion() {
      return this.cityList.length > 2 && this.curProvince !== '86'
    }
  },
  data() {
    return {
      curProvince: '',
      curCity: ''
    }
  },
  methods: {
    handleCommand(value, flag) {
      if (this.isShowSubRegion && flag === 'region') {
        this.curCity = this.cityList[0].id
      }
      this.$emit('handleCommand', Object.assign({}, { id: value, flag: flag }))
    }
  },
  watch: {
    initProvince: {
      handler(newVal) {
        this.curProvince = newVal || '86'
      },
      immediate: true
    },
    initCity: {
      handler(newVal) {
        this.curCity = newVal
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.cy-region-picker {
  display: flex;
  align-items: center;
  label {
    flex-shrink: 0;
  }
  /deep/ .el-select {
    &:nth-child(3) {
      margin-left: 10px;
    }
    .el-input {
      &__inner {
        font-family: "founder_youhei_508R";
        background-color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 22px;
      }
    }
  }
}
</style>
